import styled from 'styled-components/macro';

export const Container = styled.div`
  position: relative;
`;

export const Image = styled.img`
  position: absolute;
  cursor: pointer;
`;
